import {useMemo} from 'react';
import District, {
  CompetitionsUrlTemplate,
  MainUrlTemplate,
  MarketplaceUrlTemplate,
  MatchesCancelledUrlTemplate,
  MatchesLiveUrlTemplate,
  MatchesUrlTemplate,
  TransfersUrlTemplate,
} from 'app/models/District';

export interface DistrictUrls {
  districtMainUrl: MainUrlTemplate;
  districtMatchesUrl: MatchesUrlTemplate;
  districtCompetitionsUrl: CompetitionsUrlTemplate;
  districtMarketplaceUrl: MarketplaceUrlTemplate;
  districtTransfersUrl: TransfersUrlTemplate;
  districtMatchesLiveUrl: MatchesLiveUrlTemplate;
  districtMatchesCancelledUrl: MatchesCancelledUrlTemplate;
}

export default function useDistrictUrls(slug: string): DistrictUrls {
  const districtModel = useMemo(() => new District(slug), [slug]);

  return useMemo(() => {
    return {
      districtMainUrl: districtModel.getMainUrl(),
      districtMatchesUrl: districtModel.getMatchesUrl(),
      districtCompetitionsUrl: districtModel.getCompetitionsUrl(),
      districtMarketplaceUrl: districtModel.getMarketplaceUrl(),
      districtTransfersUrl: districtModel.getTransfersUrl(),
      districtMatchesLiveUrl: districtModel.getMatchesLiveUrl(),
      districtMatchesCancelledUrl: districtModel.getMatchesCancelledUrl(),
    };
  }, [districtModel]);
}
